
import {defineComponent} from "vue";
import {formatDateTime} from "@/helpers/functions/date";
import BaseTitle from "@/components/UI/BaseTitle.vue";
import ProductSelectionBaseSyncHistoryContent
  from "@/components/layouts/catalog/product-selection/ProductSelectionBaseSyncHistoryContent.vue";

export default defineComponent({
  name: "ProductSelectionBaseSyncHistory",
  components: {ProductSelectionBaseSyncHistoryContent, BaseTitle},
  props: {
    externalSystemTypeCode: {
      type: String,
      required: true
    },
  },
  data: () => ({
    contentKey: 0,
  }),
  methods: {
    formatDateTime,
    reloadContent(): void {
      this.contentKey++;
    }
  },

});
